export default __webpack_public_path__ + "static/media/fbf.d30ec03b.svg";